module.exports = __webpack_public_path__ + "static/media/iwin.aea71a6a.png";